import Button from 'common/components/elements/buttons/primary';
import TruncateText from 'common/components/elements/truncate-text';
import PropTypes from 'prop-types';

const MemberTagLabel = ({
   name,
   emoji,
   onClickRemove,
}) => {

   return (
      <div
         className='w-fit max-w-full px-2 h-8 rounded-full bg-panel border border-divider flex items-center gap-2'
      >
         <span>
            {emoji}
         </span>
         <TruncateText
            text={ name }
            textSize='14px'
            fontWeight='400'
            textClass='text-sm font-normal leading-[18px] text-major'
         />
         <Button
            iconName='cancel'
            padding={ 0 }
            backgroundColor='transparent'
            classNames='!w-fit'
            fontIconColor='secondary'
            fontIconSize='base'
            onClick={ onClickRemove }
            dataToolTipContent='Remove'
         />
      </div>
   )
}

MemberTagLabel.propTypes = {
   name: PropTypes.string,
   emoji: PropTypes.string,
   onClickRemove: PropTypes.func,
}


export default MemberTagLabel;
